const messageSources = [
  {
    index: 0,
    name: 'Inbox',
  },
  {
    index: 1,
    name: 'Outbox',
  },
];

export function getTabName(tabIndex: number): string {
  return messageSources.some((mode) => tabIndex === mode.index) ?
    messageSources.find((mode) => mode.index === tabIndex).name :
    'Inbox';
}
